
import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { RecommendationItem } from './types';

interface SurplusTableProps {
  items: RecommendationItem[];
  totalValue: number;
  title: string;
  subtitle: string;
}

const SurplusTable: React.FC<SurplusTableProps> = ({ 
  items, 
  totalValue, 
  title, 
  subtitle 
}) => {
  return (
    <Collapsible className="w-full rounded-md border border-primary/20 bg-secondary/30 px-4 py-2">
      <CollapsibleTrigger className="flex items-center justify-between w-full">
        <div className="flex flex-col items-start">
          <h4 className="text-primary font-semibold text-[11px]">{title}</h4>
          {totalValue > 0 && (
            <span className="text-yellow-300 text-[10px] font-medium mt-1">
              (Total Late Stage Value: ${totalValue.toLocaleString()})
            </span>
          )}
          <div className="flex items-center justify-center text-primary-light text-[9px] mt-1 w-full">
            <span className="items-center">click to expand/collapse</span>
            <ChevronDown className="h-3 w-3 text-primary-light ml-1" />
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-primary transition-transform duration-200 ui-open:rotate-90" />
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-2">
        {items.length > 0 ? (
          <ul className="list-disc pl-5 space-y-1">
            {items.map((item, index) => (
              <li key={`${subtitle}-${index}`} className="text-secondary-light text-[11px]">
                {item.accountName} 
                <span className="text-amber-300">
                  (${item.lateStageValue.toLocaleString()}
                  {item.winRatio !== undefined ? `, ${item.winRatio}%` : ''}
                  {item.achievementPercentage !== undefined ? `, ${item.achievementPercentage.toFixed(1)}%` : ''}
                  )
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <span className="text-sm text-primary-light pl-2">No accounts found</span>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default SurplusTable;
